import React from 'react';

export const getFormattedPhone =(phoneNumber) => {
  const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  return phoneNumber.replace(phoneRegex, '($1) $2-$3')
}
